const t = "{{currentTime}} av {{duration}}", n = "Sökresultat {{current}} av {{total}}", s = "Inga resultat hittades", e = "{{count}} resultat hittades", o = "{{count}} resultat hittades", r = 'Spelar upp från $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) och $t(SECONDS, { "count": {{seconds}} }).', A = 'Spelar upp från $t(MINUTES, { "count": {{minutes}} }) och $t(SECONDS, { "count": {{seconds}} }).', c = 'Spelar upp från $t(SECONDS, { "count": {{seconds}} }).', E = "Ett fel inträffade när ändringar skulle sparas till avskriften.", a = "Avskriftsrad vid {{time}}. Innehållet är: {{text}}.", T = 'Behållare för avskriftsrader. Det finns $t(TRANSCRIPT_LINES, { "count": {{count}} }) i den här containern. Använd nedåtpilstangenten för att navigera inuti den här containern.', S = "Sparar ändringar …", _ = "Ändringarna sparades till avskriften.", i = "Uppdatering av textknappen finns nu tillgänglig.", N = "Åtgärd", R = "Lägg till notering vid {{time}}", I = "Lägg till fråga vid {{time}}", O = "Noteringar", l = "Automatisk", p = "Automatisk ({{quality}})", u = "Tillbaka", C = "Undertexter", U = "Språk för undertext", g = "Hantera undertexter", P = "Ta bort {{language}}", d = "Teckenstorlek", L = "Undertextspråk: {{language}}", k = "{{language}} (automatisk", D = "Rensa sökning", v = "Stäng", M = "Kommentarer", m = "Fortsätt", f = "Minska uppspelningshastigheten", h = "Minska volymen med {{percent}}%", G = "Nedåtpil", Y = "Stäng avskriftsredigeraren", H = "Uppdatera texter", V = "Fel!", K = "Sparar ...", B = "Sparad!", F = "Redigera avskrift", x = "Texten får inte vara tom!", y = "Helskärm", W = "{{count}} timme", $ = "{{count}} timmar", Q = "Öka uppspelningshastigheten", J = "Öka volymen med {{percent}}%", b = "Invertera färger", q = "Invertera färger", X = "Hoppa till start", Z = "Åtgärder för {{title}}", z = "Kortkommandon", j = "Språk", w = "Vänster pil", tt = "Huvudmeny", nt = "{{count}} minut", st = "{{count}} minuter", et = "Tyst", ot = "Tystad", rt = "Nästa undertextspråk", At = "Nästa sökresultat", ct = "Av", Et = "Överst", at = "Öppna notering vid {{time}}", Tt = "Öppna slutfört quiz vid {{time}}", St = "Öppna quizet vid {{time}}", _t = "Pausa", it = "Spela upp", Nt = "Uppspelningshastighet", Rt = "Uppspelningshastighet: {{speed}}x", It = "Föregående undertextspråk", Ot = "Föregående sökresultat", lt = "Kvalitet", pt = "Kvalitetsmeny", ut = "Spela upp igen", Ct = "Återställ uppspelningshastigheten", Ut = "Högerpil", gt = "Sök i avskriften", Pt = "{{count}} sekund", dt = "{{count}} sekunder", Lt = "Sök bakåt: {{seconds}} sekunder", kt = "Sök framåt: {{seconds}} sekunder", Dt = "Inställningar", vt = "Genväg", Mt = "Medieinformation och verktyg", mt = "Blanksteg", ft = "Meny för uppspelningshastighet", ht = "Starta automatisk bläddring", Gt = "Undertexter av/på", Yt = "Reglage tystat", Ht = "Reglage för Spela upp/pausa", Vt = "är {{count}} avskriftsrad", Kt = "är {{count}} avskriftsrader", Bt = "Läser in avskrift …", Ft = "Det gick inte att läsa in avskriften.", xt = "Avskriftsalternativ", yt = "Försök igen", Wt = "Avskriften är inte tillgänglig", $t = "Uppåtpil", Qt = "Videoinställningar", Jt = "Volym", bt = "Volym: {{volume}}%", qt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: n,
  A11Y_SEARCH_NO_RESULTS: s,
  A11Y_SEARCH_RESULTS_FOUND: e,
  A11Y_SEARCH_RESULTS_FOUND_other: o,
  A11Y_TIMESTAMP_JUMP_HOURS: r,
  A11Y_TIMESTAMP_JUMP_MINUTES: A,
  A11Y_TIMESTAMP_JUMP_SECONDS: c,
  A11Y_TRANSCRIPT_ERROR: E,
  A11Y_TRANSCRIPT_LINE: a,
  A11Y_TRANSCRIPT_LINES: T,
  A11Y_TRANSCRIPT_SAVING: S,
  A11Y_TRANSCRIPT_SUCCESS: _,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: i,
  ACTION: N,
  ADD_ANNOTATION_AT: R,
  ADD_QUESTION_AT: I,
  ANNOTATIONS: O,
  AUTO: l,
  AUTO_QUALITY: p,
  BACK: u,
  CAPTIONS: C,
  CAPTIONS_LANGUAGE: U,
  CAPTIONS_MANAGE: g,
  CAPTION_DELETE: P,
  CAPTION_FONT_SIZE: d,
  CAPTION_LANGUAGE: L,
  CAPTION_LANGUAGE_AUTOMATIC: k,
  CLEAR_SEARCH: D,
  CLOSE: v,
  COMMENTS: M,
  CONTINUE: m,
  DECREASE_PLAYBACK_SPEED: f,
  DECREASE_VOLUME: h,
  DOWN_ARROW: G,
  EDIT_CLOSE: Y,
  EDIT_CONFIRM: H,
  EDIT_ERROR: V,
  EDIT_SAVING: K,
  EDIT_SUCCESS: B,
  EDIT_TRANSCRIPT: F,
  EDIT_VALIDATION_ERROR: x,
  FULLSCREEN: y,
  HOURS: W,
  HOURS_other: $,
  INCREASE_PLAYBACK_SPEED: Q,
  INCREASE_VOLUME: J,
  INVERT_COLORS: b,
  JUMP_TO_PERCENTAGE: q,
  JUMP_TO_START: X,
  KEBAB_MENU: Z,
  KEYBOARD_SHORTCUTS: z,
  LANGUAGE: j,
  LEFT_ARROW: w,
  MAIN_MENU: tt,
  MINUTES: nt,
  MINUTES_other: st,
  MUTE: et,
  MUTED: ot,
  NEXT_CAPTION_LANGUAGE: rt,
  NEXT_HIT: At,
  OFF: ct,
  ON_TOP: Et,
  OPEN_ANNOTATION_AT: at,
  OPEN_COMPLETED_QUIZ_AT: Tt,
  OPEN_QUIZ_AT: St,
  PAUSE: _t,
  PLAY: it,
  PLAYBACK_SPEED: Nt,
  PLAYBACK_SPEED_MESSAGE: Rt,
  PREVIOUS_CAPTION_LANGUAGE: It,
  PREVIOUS_HIT: Ot,
  QUALITY: lt,
  QUALITY_MENU: pt,
  REPLAY: ut,
  RESET_PLAYBACK_SPEED: Ct,
  RIGHT_ARROW: Ut,
  SEARCH_TRANSCRIPT_PLACEHOLDER: gt,
  SECONDS: Pt,
  SECONDS_other: dt,
  SEEK_BACKWARD: Lt,
  SEEK_FORWARD: kt,
  SETTINGS: Dt,
  SHORTCUT: vt,
  SIDEBAR: Mt,
  SPACE: mt,
  SPEED_MENU: ft,
  START_AUTOSCROLL: ht,
  TOGGLE_CAPTIONS: Gt,
  TOGGLE_MUTED: Yt,
  TOGGLE_PLAY_PAUSE: Ht,
  TRANSCRIPT_LINES: Vt,
  TRANSCRIPT_LINES_other: Kt,
  TRANSCRIPT_LOADING: Bt,
  TRANSCRIPT_LOAD_ERROR: Ft,
  TRANSCRIPT_OPTIONS: xt,
  TRANSCRIPT_RETRY: yt,
  TRANSCRIPT_UNAVAILABLE: Wt,
  UP_ARROW: $t,
  VIDEO_SETTINGS: Qt,
  VOLUME: Jt,
  VOLUME_VALUE: bt
};
export {
  t as A11Y_DURATION,
  n as A11Y_SEARCH_HITS,
  s as A11Y_SEARCH_NO_RESULTS,
  e as A11Y_SEARCH_RESULTS_FOUND,
  o as A11Y_SEARCH_RESULTS_FOUND_other,
  r as A11Y_TIMESTAMP_JUMP_HOURS,
  A as A11Y_TIMESTAMP_JUMP_MINUTES,
  c as A11Y_TIMESTAMP_JUMP_SECONDS,
  E as A11Y_TRANSCRIPT_ERROR,
  a as A11Y_TRANSCRIPT_LINE,
  T as A11Y_TRANSCRIPT_LINES,
  S as A11Y_TRANSCRIPT_SAVING,
  _ as A11Y_TRANSCRIPT_SUCCESS,
  i as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  N as ACTION,
  R as ADD_ANNOTATION_AT,
  I as ADD_QUESTION_AT,
  O as ANNOTATIONS,
  l as AUTO,
  p as AUTO_QUALITY,
  u as BACK,
  C as CAPTIONS,
  U as CAPTIONS_LANGUAGE,
  g as CAPTIONS_MANAGE,
  P as CAPTION_DELETE,
  d as CAPTION_FONT_SIZE,
  L as CAPTION_LANGUAGE,
  k as CAPTION_LANGUAGE_AUTOMATIC,
  D as CLEAR_SEARCH,
  v as CLOSE,
  M as COMMENTS,
  m as CONTINUE,
  f as DECREASE_PLAYBACK_SPEED,
  h as DECREASE_VOLUME,
  G as DOWN_ARROW,
  Y as EDIT_CLOSE,
  H as EDIT_CONFIRM,
  V as EDIT_ERROR,
  K as EDIT_SAVING,
  B as EDIT_SUCCESS,
  F as EDIT_TRANSCRIPT,
  x as EDIT_VALIDATION_ERROR,
  y as FULLSCREEN,
  W as HOURS,
  $ as HOURS_other,
  Q as INCREASE_PLAYBACK_SPEED,
  J as INCREASE_VOLUME,
  b as INVERT_COLORS,
  q as JUMP_TO_PERCENTAGE,
  X as JUMP_TO_START,
  Z as KEBAB_MENU,
  z as KEYBOARD_SHORTCUTS,
  j as LANGUAGE,
  w as LEFT_ARROW,
  tt as MAIN_MENU,
  nt as MINUTES,
  st as MINUTES_other,
  et as MUTE,
  ot as MUTED,
  rt as NEXT_CAPTION_LANGUAGE,
  At as NEXT_HIT,
  ct as OFF,
  Et as ON_TOP,
  at as OPEN_ANNOTATION_AT,
  Tt as OPEN_COMPLETED_QUIZ_AT,
  St as OPEN_QUIZ_AT,
  _t as PAUSE,
  it as PLAY,
  Nt as PLAYBACK_SPEED,
  Rt as PLAYBACK_SPEED_MESSAGE,
  It as PREVIOUS_CAPTION_LANGUAGE,
  Ot as PREVIOUS_HIT,
  lt as QUALITY,
  pt as QUALITY_MENU,
  ut as REPLAY,
  Ct as RESET_PLAYBACK_SPEED,
  Ut as RIGHT_ARROW,
  gt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Pt as SECONDS,
  dt as SECONDS_other,
  Lt as SEEK_BACKWARD,
  kt as SEEK_FORWARD,
  Dt as SETTINGS,
  vt as SHORTCUT,
  Mt as SIDEBAR,
  mt as SPACE,
  ft as SPEED_MENU,
  ht as START_AUTOSCROLL,
  Gt as TOGGLE_CAPTIONS,
  Yt as TOGGLE_MUTED,
  Ht as TOGGLE_PLAY_PAUSE,
  Vt as TRANSCRIPT_LINES,
  Kt as TRANSCRIPT_LINES_other,
  Bt as TRANSCRIPT_LOADING,
  Ft as TRANSCRIPT_LOAD_ERROR,
  xt as TRANSCRIPT_OPTIONS,
  yt as TRANSCRIPT_RETRY,
  Wt as TRANSCRIPT_UNAVAILABLE,
  $t as UP_ARROW,
  Qt as VIDEO_SETTINGS,
  Jt as VOLUME,
  bt as VOLUME_VALUE,
  qt as default
};
